/** Preferred display keys for hierarchy / lookup nodes. */
const PREFERRED_LABEL_KEYS = [
  'kgid_number',
  'kgidNumber',
  'KGIDNumber',
  'KGID_NUMBER',
  'section_name',
  'sectionName',
  'SectionName',
  'SECTION_NAME',
  'sub_section_name',
  'subSectionName',
  'SubSectionName',
  'SUB_SECTION_NAME',
  'designation_name',
  'designationName',
  'DesignationName',
  'DESIGNATION_NAME',
  'section',
  'sub_section',
  'subSection',
  'name',
  'label',
  'title',
] as const;

const FALLBACK_SKIP_KEYS = new Set([
  'kgid_code',
  'kgidCode',
  'KGID_CODE',
  'section_code',
  'sectionCode',
  'SECTION_CODE',
  'sub_section_code',
  'subSectionCode',
  'SUB_SECTION_CODE',
  'designation_code',
  'designationCode',
  'DESIGNATION_CODE',
]);

function pickLabelValue(value: unknown): string | null {
  if (value == null || typeof value === 'object') return null;
  const text = String(value).trim();
  return text || null;
}

function hasLetters(text: string): boolean {
  return /[A-Za-z]/.test(text);
}

function isPreferredNameLikeKey(key: string): boolean {
  const k = key.toLowerCase();
  return k.includes('name') || k.includes('title') || k.includes('label');
}

/** Human label for a hierarchy node's dynamic `data` payload. */
export function nodeLabel(n: { id: number; data?: Record<string, unknown> | null }): string {
  const d = n.data || {};
  for (const key of PREFERRED_LABEL_KEYS) {
    const picked = pickLabelValue(d[key]);
    if (picked) return picked;
  }
  for (const [key, value] of Object.entries(d)) {
    if (FALLBACK_SKIP_KEYS.has(key)) continue;
    const picked = pickLabelValue(value);
    if (picked && isPreferredNameLikeKey(key)) return picked;
  }
  for (const [key, value] of Object.entries(d)) {
    if (FALLBACK_SKIP_KEYS.has(key)) continue;
    const picked = pickLabelValue(value);
    if (picked && hasLetters(picked)) return picked;
  }
  for (const [key, value] of Object.entries(d)) {
    if (FALLBACK_SKIP_KEYS.has(key)) continue;
    const picked = pickLabelValue(value);
    if (picked) return picked;
  }
  return `#${n.id}`;
}
